import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import TextWrapper from '@r1-frontend/ui-react/components/typography/TextWrapper';

import EntitiesContainer from '~/src/features/tariffBuilder/containers/EntitiesContainer';
import { TEntityDescription } from '~/src/features/tariffBuilder/reducer/initialState';
import { EEntity } from '~/src/features/tariffBuilder/types/EEntity';

const AdditionalSubscriptionsBlock = ({ header, description }: TEntityDescription): JSX.Element => {
    const defaultDescription = <>
        Будте уверены&nbsp;&mdash; интернет не пропадет и в нужный момент будет всегда под рукой.
        Сеть под нашим контролем круглосуточно
    </>;

    return (
        <>
            <TextWrapper>
                <H3>{header ? header : 'Книги, игры, музыка и экономия'}</H3>
                {description
                    ? <Paragraph4 $smaller dangerouslySetInnerHTML={{ __html: description }} />
                    : <Paragraph4 $smaller>{defaultDescription}</Paragraph4>
                }
            </TextWrapper>

            <EntitiesContainer entityName={EEntity.additional}/>
        </>
    );
};

export default AdditionalSubscriptionsBlock;
